import { vismaRoleEnum, vismaStatus } from './DTOEnums'

export const isDebtCollectionInvoice = (invoice) =>
  invoice.vismaRole === vismaRoleEnum.DEBT_COLLECTION &&
  (invoice.vismaStatus === vismaStatus.COLLECTING ||
    invoice.vismaStatus === vismaStatus.COLLECTION_PROHIBITION_ON ||
    invoice.vismaStatus === vismaStatus.NOT_SENT ||
    invoice.vismaStatus === vismaStatus.SUSPENDED)
